import { defaultLocale, type Locale } from "@/lib/i18n";
import type { AgentUseCase } from "./types";
import { creditEvaluation } from "./credit-evaluation";
import { orderProcessing } from "./order-processing";
import { productEnquiry } from "./product-enquiry";
import { supportTriage } from "./support-triage";
import { invoiceMatching } from "./invoice-matching";
import { cashApplication } from "./cash-application";
import { leaveManagement } from "./leave-management";
import { bankReconciliation } from "./bank-reconciliation";
import { insuranceClaims } from "./insurance-claims";
import { kycOnboarding } from "./kyc-onboarding";
import { contractReview } from "./contract-review";
import { hrVerification } from "./hr-verification";
import { knowledgeAgent } from "./knowledge-agent";
import { corporateComms } from "./corporate-comms";

// Every use case is now a full spoke. Ordered roughly by breadth of appeal —
// customer-facing / WhatsApp use cases first, then the document-heavy back-office ones.
export const agentUseCases: AgentUseCase[] = [
  orderProcessing,
  productEnquiry,
  supportTriage,
  knowledgeAgent,
  corporateComms,
  creditEvaluation,
  invoiceMatching,
  cashApplication,
  bankReconciliation,
  insuranceClaims,
  kycOnboarding,
  contractReview,
  hrVerification,
  leaveManagement,
];

export function getUseCaseBySlug(slug: string): AgentUseCase | undefined {
  return agentUseCases.find((u) => u.structure.slug === slug);
}

export function getRelatedUseCases(
  slugs: string[] | undefined,
): AgentUseCase[] {
  if (!slugs) return [];
  return slugs
    .map((s) => getUseCaseBySlug(s))
    .filter((u): u is AgentUseCase => Boolean(u));
}

export type { AgentUseCase };
export { defaultLocale };
export type { Locale };
